import React, { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { FaUserCircle, FaSignOutAlt } from "react-icons/fa";
import { Container, Navbar, Breadcrumb, Card, Button } from "react-bootstrap";
import "./AdminLayout.css"; // Ensure this is imported

const AdminLayout = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear admin authentication from localStorage
    localStorage.removeItem("adminAuthenticated");
    localStorage.removeItem("adminEmail");
    
    // Dispatch custom event to notify AdminProtectedRoute
    window.dispatchEvent(new Event("adminAuthChange"));
    
    // Redirect to admin login page
    navigate("/admin");
  };

  // Map routes to readable titles
  const pageTitles = {
    "/admin": "Dashboard",
    "/admin/users": "User Management",
    "/admin/products": "Product Management",
    "/admin/settings": "Admin Settings",
    "/logout": "Logout",
  };

  // Generate breadcrumbs from the URL
  const breadcrumbs = location.pathname
    .split("/")
    .filter((crumb) => crumb)
    .map((crumb, index, arr) => (
      <Breadcrumb.Item key={index} active={index === arr.length - 1}>
        {crumb.replace("-", " ")}
      </Breadcrumb.Item>
    ));

  return (
    <div className="d-flex min-vh-100">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="content flex-grow-1 p-4">
        <Navbar className="bg-white shadow-sm rounded p-3 mb-4">
          <Container fluid className="d-flex justify-content-between align-items-center">
            <h1 className="h4 fw-bold">Admin Panel</h1>
            <div className="d-flex align-items-center gap-3">
              <span className="text-muted">Welcome, Admin</span>
              <FaUserCircle size={28} className="text-secondary" />
              <Button
                variant="outline-danger"
                onClick={handleLogout}
                className="d-flex align-items-center gap-2"
                style={{ borderColor: "#dc3545", color: "#dc3545" }}
              >
                <FaSignOutAlt />
                Logout
              </Button>
            </div>
          </Container>
        </Navbar>

        {/* Breadcrumbs */}
        <Breadcrumb className="mb-3">{breadcrumbs}</Breadcrumb>

        {/* Page Content */}
        <Card className="shadow-sm p-3 bg-white">
          <Outlet />
        </Card>
      </div>
    </div>

  );
};

export default AdminLayout;
